import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import app from './firebase';

const firestore = getFirestore(app);

/* Uncomment to use local emulators: */
 connectFirestoreEmulator(firestore, 'localhost', 8080);

export default firestore;